import { Route } from "react-router";
import { RoutePathProps } from "../../../AppRoutes/types";
import { addChildRoute } from "../../../AppRoutes/utils";
import { purchases } from "../purchases/PurchasesRoutes";
import { sales } from "../sales/SalesRoutes";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ListSalesInvoice from "../sales/pages/SalesInvoice/ListSalesInvoice";
import CreateSalesInvoice from "../sales/pages/SalesInvoice/CreateSalesInvoive";
import ShowSalesInvoice from "../sales/pages/SalesInvoice/ShowSalesInvoice";
import ListQuotation from "../sales/pages/Quotation/ListQuotation";
import CreateQuotation from "../sales/pages/Quotation/CreateQuotation";
import ShowQuotation from "../sales/pages/Quotation/ShowQuotation";
import ListPaymentIn from "../sales/pages/PaymentIn/ListPaymentIn";
import CreatePaymentIn from "../sales/pages/PaymentIn/CreatePaymentIn";
import ShowPaymentIn from "../sales/pages/PaymentIn/ShowPaymentIn";
import ListSalesReturn from "../sales/pages/SalesReturn/ListSalesReturn";
import CreateSalesReturn from "../sales/pages/SalesReturn/CreateSalesReturn";
import ShowSalesReturn from "../sales/pages/SalesReturn/ShowSalesReturn";
import ListCreditNote from "../sales/pages/CreditNote/ListCreditNote";
import CreateCreditNote from "../sales/pages/CreditNote/CreateCreditNote";
import ShowCreditNote from "../sales/pages/CreditNote/ShowCreditNote";
import ListPurchaseInvoice from "../purchases/pages/PurchaseInvoice/ListPurchaseInvoice";
import CreatePurchaseInvoice from "../purchases/pages/PurchaseInvoice/CreatePurchaseInvoive";
import ShowPurchaseInvoice from "../purchases/pages/PurchaseInvoice/ShowPurchaseInvoice";
import ListPurchaseReturn from "../purchases/pages/PurchaseReturn/ListPurchaseReturn";
import CreatePurchaseReturn from "../purchases/pages/PurchaseReturn/CreatePurchaseReturn";
import ShowPurchaseReturn from "../purchases/pages/PurchaseReturn/ShowPurchaseReturn";
import ListDebitNote from "../purchases/pages/DebitNote/ListDebitNote";
import CreateDebitNote from "../purchases/pages/DebitNote/CreateDebitNote";
import ShowDebitNote from "../purchases/pages/DebitNote/ShowDebitNote";
import ListPaymentOut from "../purchases/pages/PaymentOut/ListPaymentOut";
import CreatePaymentOut from "../purchases/pages/PaymentOut/CreatePaymentOut";
import ShowPaymentOut from "../purchases/pages/PaymentOut/ShowPaymentOut";

const accounts: RoutePathProps = addChildRoute({
    name: 'accounts',
    path: 'accounts',
    label: 'Accounts',
    visibleInNav: true,
    icon: AccountBalanceIcon,
    dummy: true,
    children: [sales, purchases],
    requiredPermission:'account:list'
}, {
    sales, purchases
})

const AccountsRoutes = (
    <>
        <Route path={accounts.path} element={<ListSalesInvoice />} />
        <Route path={accounts.children?.[0].path} element={<ListSalesInvoice />} />

        <Route path={accounts.children?.[0].children?.[0].path} element={<ListSalesInvoice />} />
        <Route path={accounts.children?.[0].children?.[0].children?.[0].path} element={<CreateSalesInvoice />} />
        <Route path={accounts.children?.[0].children?.[0].children?.[1].path} element={<ShowSalesInvoice />} />
        <Route path={accounts.children?.[0].children?.[0].children?.[2].path} element={<CreateSalesInvoice />} />

        {/* <Route path={accounts.children?.[0].children?.[0].children?.[1].path} element={<AddEditEmployee />} />
        <Route path={accounts.children?.[0].children?.[0].children?.[2].path} element={<AddEditEmployee />} /> */}

        <Route path={accounts.children?.[0].children?.[1].path} element={<ListQuotation />} />
        <Route path={accounts.children?.[0].children?.[1].children?.[0].path} element={<CreateQuotation />} />
        <Route path={accounts.children?.[0].children?.[1].children?.[1].path} element={<ShowQuotation />} />
        <Route path={accounts.children?.[0].children?.[1].children?.[2].path} element={<CreateQuotation />} />
        {/* <Route path={accounts.children?.[0].children?.[1].children?.[1].path} element={<AddEditAttendance />} /> */}

        <Route path={accounts.children?.[0].children?.[2].path} element={<ListPaymentIn />} />
        <Route path={accounts.children?.[0].children?.[2].children?.[0].path} element={<CreatePaymentIn />} />
        <Route path={accounts.children?.[0].children?.[2].children?.[1].path} element={<ShowPaymentIn />} />
        <Route path={accounts.children?.[0].children?.[2].children?.[2].path} element={<CreatePaymentIn />} />


        <Route path={accounts.children?.[0].children?.[3].path} element={<ListSalesReturn />} />
        <Route path={accounts.children?.[0].children?.[3].children?.[0].path} element={<CreateSalesReturn />} />
        <Route path={accounts.children?.[0].children?.[3].children?.[1].path} element={<ShowSalesReturn />} />
        <Route path={accounts.children?.[0].children?.[3].children?.[2].path} element={<CreateSalesReturn />} />


        <Route path={accounts.children?.[0].children?.[4].path} element={<ListCreditNote />} />
        <Route path={accounts.children?.[0].children?.[4].children?.[0].path} element={<CreateCreditNote />} />
        <Route path={accounts.children?.[0].children?.[4].children?.[1].path} element={<ShowCreditNote />} />
        <Route path={accounts.children?.[0].children?.[4].children?.[2].path} element={<CreateCreditNote />} />

        {/* PURCHASE ROUTES---------------------------------------------------------------------------------- */}
        <Route path={accounts.children?.[1].children?.[0].path} element={<ListPurchaseInvoice />} />
        <Route path={accounts.children?.[1].children?.[0].children?.[0].path} element={<CreatePurchaseInvoice />} />
        <Route path={accounts.children?.[1].children?.[0].children?.[1].path} element={<ShowPurchaseInvoice />} />
        <Route path={accounts.children?.[1].children?.[0].children?.[2].path} element={<CreatePurchaseInvoice />} />

        <Route path={accounts.children?.[1].children?.[1].path} element={<ListPaymentOut />} />
        <Route path={accounts.children?.[1].children?.[1].children?.[0].path} element={<CreatePaymentOut />} />
        <Route path={accounts.children?.[1].children?.[1].children?.[1].path} element={<ShowPaymentOut />} />
        <Route path={accounts.children?.[1].children?.[1].children?.[2].path} element={<CreatePaymentOut />} />

        <Route path={accounts.children?.[1].children?.[2].path} element={<ListPurchaseReturn />} />
        <Route path={accounts.children?.[1].children?.[2].children?.[0].path} element={<CreatePurchaseReturn />} />
        <Route path={accounts.children?.[1].children?.[2].children?.[1].path} element={<ShowPurchaseReturn />} />
        <Route path={accounts.children?.[1].children?.[2].children?.[2].path} element={<CreatePurchaseReturn />} />

        <Route path={accounts.children?.[1].children?.[3].path} element={<ListDebitNote />} />
        <Route path={accounts.children?.[1].children?.[3].children?.[0].path} element={<CreateDebitNote />} />
        <Route path={accounts.children?.[1].children?.[3].children?.[1].path} element={<ShowDebitNote />} />
        <Route path={accounts.children?.[1].children?.[3].children?.[2].path} element={<CreateDebitNote />} />

    </>
)

export const accountsPaths = [accounts];
export default AccountsRoutes;